<template>
  <div>
    <el-image class="policyType4-banner" :src="require('@/assets/images/policy/policyType4-banner.png')"></el-image>
    <el-row class="policyType4-row">
      <el-image @click="goExternalLink('https://gaokao.chsi.com.cn/gkxx/zcdh/202001/20200115/1872624417.html')"
        :src="require('@/assets/images/policy/policyType4-info.png')">
      </el-image>
      <el-image @click="goExternalLink('https://gaokao.chsi.com.cn/gkzt/jcxkzs#jcxkzs-sch')"
        :src="require('@/assets/images/policy/policyType4-entry.png')" style="margin-left: 20px;">
      </el-image>
    </el-row>
    <div class="">
      <div class="part-process">
        <div class="part-title">
          <el-image class="part-title-img" :src="require('@/assets/images/policy/policyType4-process.png')"></el-image>
        </div>
        <div class="part-process-tip">（日程安排如有变动，请以高校公布的最新信息为准）</div>
        <div class="part-process-list">
          <div class="part-process-list-item"><span class="process-index">1</span>
            <div class="process-card">
              <div class="process-time">4月至5月</div>
              <div class="process-des">简章公布，网上报名</div>
            </div>
          </div>
          <div class="part-process-list-item"><span class="process-index">2</span>
            <div class="process-card">
              <div class="process-time">6月</div>
              <div class="process-des">考生参加统一高考</div>
            </div>
          </div>
          <div class="part-process-list-item"><span class="process-index">3</span>
            <div class="process-card">
              <div class="process-time">高考后、7月4日前</div>
              <div class="process-des">各省（区、市）提供高考成绩<div>高校确定考核名单并组织考核</div>
              </div>
            </div>
          </div>
          <div class="part-process-list-item"><span class="process-index">4</span>
            <div class="process-card">
              <div class="process-time">7月5日前</div>
              <div class="process-des">高校折算综合成绩，择优录取</div>
            </div>
          </div>
        </div>
      </div>
      <div class="policyType4Plan-title">
        <i class="el-icon-star-on"></i>
        <span style="margin: 0 12px;">强基计划关注点</span>
        <i class="el-icon-star-on"></i>
      </div>
      <div class="policyType4Plan">
        <div class="policyType4Plan-item">
          <h3 class="policyType4Plan-item-title">
            <div class="title-text">选拔定位</div>
          </h3>
          <div class="item-des">强基计划指导思想和原则是为国家重大战略领域输送后备人才。主要选拔培养有志于服务国家重大战略需求且综合素质优秀或基础学科拔尖的学生。</div>
        </div>
        <div class="policyType4Plan-item">
          <h3 class="policyType4Plan-item-title">
            <div class="title-text">招生专业</div>
          </h3>
          <div class="item-des">
            聚焦高端芯片与软件、智能科技、新材料、先进制造和国家安全等关键领域以及国家人才紧缺的人文社会科学领域，重点在数学、物理、化学、生物、力学、基础医学、育种及历史、哲学、古文字学等相关专业招生。
          </div>
        </div>
        <div class="policyType4Plan-item">
          <h3 class="policyType4Plan-item-title">
            <div class="title-text">试点学校</div>
          </h3>
          <div class="item-des">起步阶段遴选36所“双一流”建设高校开展试点，2022年，在36所强基计划试点高校基础上，增加了三所高校开展强基计划试点。</div>
        </div>
        <div class="policyType4Plan-item">
          <h3 class="policyType4Plan-item-title">
            <div class="title-text">招生规模</div>
          </h3>
          <div class="item-des">综合考虑高校办学定位、人才培养质量、科研项目及平台建设情况、招生和人才培养方案等因素，按照“一校一策”的原则，研究确定强基计划招生高校、专业和规模。
          </div>
        </div>
        <div class="policyType4Plan-item">
          <h3 class="policyType4Plan-item-title">
            <div class="title-text">录取方式</div>
          </h3>
          <div class="item-des">
            探索建立基于统一高考的多维度考核评价招生模式。一是按综合成绩（其中高考成绩所占比例不得低于85%）和考生志愿，由高到低顺序录取。二是对极少数在相关学科领域具有突出才能和表现的考生，可破格入围。
          </div>
        </div>
        <div class="policyType4Plan-item">
          <h3 class="policyType4Plan-item-title">
            <div class="title-text">培养模式</div>
          </h3>
          <div class="item-des">
            高校对通过强基计划录取的学生单独制定培养方案，采取导师制、小班化等培养模式。畅通成长发展通道，对学业优秀的学生，高校可在免试推荐研究生、直博、公派留学、奖学金等方面予以优先安排。</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goExternalLink(url) {
      window.open(url);
    }
  }
}
</script>

<style scoped lang="stylus">
.policyType4-banner {
  margin-top 6px
  vertical-align top
}
.policyType4-row {
  display flex
  margin-top 16px
  /deep/ {
    .el-image {
      vertical-align top
      cursor pointer
      border-radius 8px
      &:hover {
        .el-image__inner {
          transform scale(1.05)
        }
      }
    }
    .el-image__inner {
      transition all 0.3s
    }
  }
}

.part-process {
  background: none;
  padding: 20px 0;
  margin-top: 20px;
  background: #E4F3FF;
  border-radius: 8px;
}
.part-title {
  text-align: center;
}
.part-title-img {
  width: 619px;
  height: 19px;
}

.part-process-tip {
  margin: 8px 0 29px;
  font-size: 14px;
  line-height: 20px;
  color: #747474;
  text-align: center;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  line-height: 18px;
}
.part-process-list {
  display: flex;
  justify-content: center;
}

.part-process-list-item {
  text-align: center;
  position: relative;
}

.part-process-list-item::before {
  content: "";
  width: 100%;
  height: 1px;
  border-top: 1px solid #15aa8a;
  position: absolute;
  top: 16px;
  left: 0;
}
.part-process-list-item:first-child::before {
  width: 50%;
  left: auto;
  right: 0px;
}
.part-process-list-item:last-child::before {
  width: 50%;
  left: 0px;
}
.part-process-list-item:not(:last-child) {
  padding-right: 32px;
}
.process-index {
  display: inline-block;
  width: 32px;
  height: 32px;
  line-height: 24px;
  background: #15AA8A;
  border-radius: 50%;
  border: 4px solid #AEDDE1;
  text-align: center;
  color: #fff;
  font-weight: bold;
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  box-shadow: 0px 0px 0px 1px #15aa8a;
}
.process-card {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.process-time {
  font-size: 16px;
  line-height: 26px;
  margin: 4px 0 8px;
  font-weight: 600;
  font-size: 16px;
  color: #012175;
  line-height: 22px;
}
.process-des {
  width: 182px;
  height: 61px;

  font-weight: 400;
  font-size: 12px;
  color: #333333;
  line-height: 17px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.policyType4Plan-title {
  text-align center
  font-weight: 600;
  font-size: 16px;
  color: #061E69;
  line-height: 16px;
  padding: 16px 0
}

.policyType4Plan {
  // padding: 20px 0 6px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .policyType4Plan-item {
    width: 336px;
    margin-bottom: 14px;
    background-color: #E4F3FF;
    border-radius: 8px;
    overflow: hidden;
  }
  .policyType4Plan-item-title {
    text-align: center;
    margin: 0 0 12px 0;
    .title-text {
      display: inline-block;
      height: 32px;
      line-height: 32px;
      padding: 0 28px;
      background: linear-gradient(180deg, #42AFFF 0%, #003BDF 100%);
      border-radius: 0px 0px 8px 8px;
      text-align: center;
      font-size: 14px;
      color: #fff;
    }
  }
  .item-des {
    padding: 0 20px 14px;
    font-size: 14px;
    color: #333;
    line-height: 20px;
  }
}
</style>
